import { HTTP } from "@/axios.js"
import store from '@/store.js'
export default {
    zoneList: () => {
        return HTTP.get('/stock/setting/outzone-all', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    addZone: (data) => {
        return HTTP.post('/stock/setting/outzone-create',data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    editZone: (id,data) => {
        return HTTP.post(`/stock/setting/outzone-update/${id}`,data, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    detailZone: (id) => {
        return HTTP.get(`/stock/setting/outzone-edit/${id}`, {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
    userList: () => {
        return HTTP.get('/stock/setting/outzone-user-list', {
            headers: {
                "Authorization": `Bearer ${store.state.token}`
            }
        })
        .then(response => response)
    },
}